import dashActive from "../../assets/images/dashActive.svg";
import dashIA from "../../assets/images/dashIA.svg";
import locationActive from "../../assets/images/locationActive.svg";
import locationIA from "../../assets/images/locationIA.svg";
import agreementIA from "../../assets/images/agreementIA.svg";
import agreementActive from "../../assets/images/agreementActive.svg";
import purchaseIA from "../../assets/images/purchaseIA.svg";
import purchaseActive from "../../assets/images/purchaseActive.svg";
import settingIA from "../../assets/images/settingIA.svg";
import settingActive from "../../assets/images/settingActive.svg";
import ledgerActive from "../../assets/images/ledgerActive.svg";
import ledgerIA from "../../assets/images/ledgerIA.svg";
import releaseOrderIA from "../../assets/images/releaseOrderIA.svg";
import releaseOrderActive from "../../assets/images/releaseOrderActive.svg";
import approvalsIcon from "../../assets/images/approvalsIcon.svg";
import approvalsIA from "../../assets/images/approvalsIA.svg";
import dashboardActive from "../../assets/images/dashboardActive.svg";
import dashboardIA from "../../assets/images/dashboardIA.svg";
import homeActive from "../../assets/images/homeActive.svg";
import homeIA from "../../assets/images/homeIA.svg";
import groupPeopleActive from "../../assets/images/groupPeopleActive.svg";
import groupPeopleIA from "../../assets/images/groupPeopleIA.svg";
import ticketsActive from "../../assets/images/ticketsActive.svg";
import ticketsIA from "../../assets/images/ticketsIA.svg";
import bankIA from "../../assets/images/bankIA.svg";
import bankActive from "../../assets/images/bankActive.svg";
import { release } from "redux/reducer/releaseTabs";

const permissions = {
  create: false,
  view: true,
  edit: false,
  delete: false,
};

export const userData = {
  role: "CUSTOMER",
  dashboard: { ...permissions },
  submitRequest: { ...permissions },
  purchaseOrder: { ...permissions },
  documents: { ...permissions },
  agreements: { ...permissions },
  releasePdf: { ...permissions },
  purchaseOrders: { ...permissions },
  releaseOrders: { ...permissions },
  transactions: { ...permissions },
  history: { ...permissions },
  ongoing: { ...permissions },
  storage: { ...permissions },
  purchase: { ...permissions },
  release: { ...permissions },
  thirdPartyBuyRequest: { ...permissions },
  payments: { ...permissions },
  downloadLedger: { ...permissions },
  setting: { ...permissions },
  releaseRequests: { ...permissions },
}; //1

export const supplierData = {
  role: "SUPPLIER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  downloadLedger: { ...permissions },
  //commodityDeposits: { ...permissions },
  purchaseorders: { ...permissions },
  completed: { ...permissions },
  ongoing: { ...permissions },
  payments: { ...permissions },
  totalbillraised: { ...permissions },
  qualityandquantitydiscount: { ...permissions },
  outstanding: { ...permissions },
  submittedBids: { ...permissions },
  ongoingBids: { ...permissions },
  bidQuotationRequests: { ...permissions },
}; //1

export const businessDevData = {
  role: "BDE",
  dashboard: { ...permissions },
  submitRequest: { ...permissions },
  setting: { ...permissions },
  purchaseOrders: { ...permissions },
  onBoardings: { ...permissions },
  customer: { ...permissions },
  releaseOrders: { ...permissions },
}; //3

export const superAdminData = {
  role: "SUPER ADMIN",
  dashboard: { ...permissions },
  setting: { ...permissions },
  teamMembers: { ...permissions },
  onboards: { ...permissions },
  agreements: { ...permissions },
  pendingApproval: { ...permissions },
  ticket: { ...permissions },
  depositedCommodities: { ...permissions },
  valueChainManagement: { ...permissions },
};

export const cogData = {
  role: "COG - COMMERCIAL TEAM - MEMBER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  depositedCommodities: { ...permissions },
  supplierBids: { ...permissions },
  addendum: { ...permissions },
  requestsSubmitted: { ...permissions },
  valueChainManage: { ...permissions },
  cogApprovals: { ...permissions },
  purchaseRequest: { ...permissions },
  depositUpdate: { ...permissions },
  allTransactions: { ...permissions },
}; //5

export const agentData = {
  role: "AGENT",
  dashboard: { ...permissions },
  //commodityDeposits: { ...permissions },
  purchaseorders: { ...permissions },
  completed: { ...permissions },
  ongoing: { ...permissions },
  setting: { ...permissions },
}; //6

export const areaManagerData = {
  role: "AREA MANAGER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  onBoardings: { ...permissions },
  customer: { ...permissions },
  bde: { ...permissions },
  commodities: { ...permissions },
  locations: { ...permissions },
  grainManager: { ...permissions },
  proposalSubmission: { ...permissions },
  submitRequest: { ...permissions },
  clusterManager: { ...permissions },

  // approvals: { ...permissions },
}; //7

export const zonalManagerData = {
  role: "ZONAL MANAGER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  onBoardings: { ...permissions },
  tickets: { ...permissions },
  clusterManager: { ...permissions },
  areaManager: { ...permissions },
  bde: { ...permissions },
  commodities: { ...permissions },
  location: { ...permissions },
  customer: { ...permissions },
  supplier: { ...permissions },
}; //8

export const clusterManagerData = {
  role: "CLUSTER MANAGER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  onBoardings: { ...permissions },
  bde: { ...permissions },
  commodities: { ...permissions },
  tickets: { ...permissions },
  location: { ...permissions },
  customer: { ...permissions },
  supplier: { ...permissions },
}; //9

export const businessHeadData = {
  role: "BUSINESS HEAD",
  dashboard: { ...permissions },
  setting: { ...permissions },
  onBoardings: { ...permissions },
  tickets: { ...permissions },
  clusterManager: { ...permissions },
  zonalManager: { ...permissions },
  grainManager: { ...permissions },
  areaManager: { ...permissions },
  bde: { ...permissions },
  commodities: { ...permissions },
  location: { ...permissions },
  customer: { ...permissions },
  supplier: { ...permissions },
}; //10

export const grainManagerData = {
  role: "GRAIN MANAGER",
  dashboard: { ...permissions },
  setting: { ...permissions },
  bookings: { ...permissions },
  maintenance: { ...permissions },
  fumigationAndSpraying: { ...permissions },
  commodityDeposits: { ...permissions },
  commodityHealth: { ...permissions },
  commodityRelease: { ...permissions },
}; //11

export const qualityManagerData = {
  role: "QUALITY MANAGER",
  dashboard: { ...permissions },
  qualityManager: { ...permissions },
  pendingTasks: { ...permissions },
};

export const grainDepositorData = {
  role: "GRAIN DEPOSITOR",
  dashboard: { ...permissions },
  reservationHistory: { ...permissions },
  agreementExecute: { ...permissions },
  stockReport: { ...permissions },
  warhouseReceiptRequest: { ...permissions },
  outstandingInvoice: { ...permissions },
  overAllLedger: { ...permissions },
  banking: { ...permissions },
  myagents: { ...permissions },
  payments: { ...permissions },
  warehouse: { ...permissions },
  quotation: { ...permissions },
  certificates: { ...permissions },
  customerCare: { ...permissions },
  tickets: { ...permissions },
}; //12

export const cogOnboardingData = {
  role: "COG - ONBOARDING TEAM - MEMBER",
  dashboard: { ...permissions },
  customers: { ...permissions },
  warehouses: { ...permissions },
  location: { ...permissions },
  manpower: { ...permissions },
  insurancePolicy: { ...permissions },
  commodityList: { ...permissions },
  vendor: { ...permissions },
}; //13

export const financeData = {
  role: "FINANCE - TEAM MEMBER",
  dashboard: { ...permissions },
  allTransaction: { ...permissions },
  releaseRate: { ...permissions },
  deposits: { ...permissions },
  invoice: { ...permissions },
  valueChainManage: { ...permissions },
}; //1

export const commonNavLink = [
  {
    to: "/admin/setting",
    label: "Settings",
    iconName: settingActive,
    inactiveIcon: settingIA,
    //privilegesName: "setting",
  },
];

export const navLinkContractUsers = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/proposal-order",
    label: "My Transactions",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "submitRequest",
  },
];

export const navLinkUsers = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  // {
  //   to: "/admin/submit-request",
  //   label: "Submit Request",
  //   iconName: dashActive,
  //   inactiveIcon: dashIA,
  //   privilegesName: "submitRequest",
  // },
  // {
  //   to: "/admin/proposal-order",
  //   label: "Proposal",
  //   iconName: ledgerActive,
  //   inactiveIcon: ledgerIA,
  //   privilegesName: "purchaseOrder",
  // },
  {
    to: "/admin/proposal-order",
    label: "My Transactions",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "submitRequest",
  },
  {
    to: "/admin/documents/agreements",
    label: "Agreements",
    iconName: agreementActive,
    inactiveIcon: agreementIA,
    privilegesName: "agreements",
  },
  {
    to: "",
    label: "Ongoing Transactions",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "transactions",
    subNav: [
      {
        to: "/admin/transactions/purchase",
        label: "Purchase",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "purchase",
      },
      {
        to: "/admin/transactions/storage",
        label: "Storage",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "storage",
      },
      {
        to: "/admin/transactions/release",
        label: "Release",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "release",
      },
      {
        to: "/admin/transactions/thirdPartyByRequest",
        label: "Third Party Buy Request",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "release",
      },
    ],
    // subNav: [
    //   {
    //     to: "/admin/transactions/history",
    //     label: "History",
    //     iconName: ledgerActive,
    //     inactiveIcon: ledgerIA,
    //     privilegesName: "history",
    //   },
    //   {
    //     to: "",
    //     label: "Ongoing",
    //     iconName: locationIA,
    //     inactiveIcon: locationIA,
    //     privilegesName: "ongoing",
    //     ternaryNav: [
    //       {
    //         to: "/admin/transactions/purchase",
    //         label: "Purchase",
    //         iconName: ledgerActive,
    //         inactiveIcon: ledgerIA,
    //         privilegesName: "purchase",
    //       },
    //       {
    //         to: "/admin/transactions/storage",
    //         label: "Storage",
    //         iconName: ledgerActive,
    //         inactiveIcon: ledgerIA,
    //         privilegesName: "storage",
    //       },
    //       {
    //         to: "/admin/transactions/release",
    //         label: "Release",
    //         iconName: ledgerActive,
    //         inactiveIcon: ledgerIA,
    //         privilegesName: "release",
    //       },
    //     ],
    //   },
    // ],
  },
  {
    to: "/admin/documents/release-pdf",
    label: "Release Pdf",
    iconName: agreementActive,
    inactiveIcon: agreementIA,
    privilegesName: "releasePdf",
  },
  // {
  //   to: "/admin/documents/release-pdf/id",
  //   label: "Release Pdf",
  //   iconName: agreementActive,
  //   inactiveIcon: agreementIA,
  //   privilegesName: "releasePdf",
  // },
  {
    to: "",
    label: "Reports",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "documents",
    subNav: [
      {
        to: "/admin/reports/purchase-requests",
        label: "Purchase Request",
        iconName: agreementActive,
        inactiveIcon: agreementIA,
        privilegesName: "purchaseOrders",
      },
      {
        to: "/admin/reports/storage",
        label: "Storage",
        iconName: purchaseActive,
        inactiveIcon: purchaseIA,
        privilegesName: "storage",
      },
      {
        to: "/admin/reports/release-requests",
        label: "Release Requests",
        iconName: releaseOrderActive,
        inactiveIcon: releaseOrderIA,
        privilegesName: "releaseRequests",
      },
      {
        to: "/admin/reports/release-orders",
        label: "Release Orders",
        iconName: releaseOrderActive,
        inactiveIcon: releaseOrderIA,
        privilegesName: "releaseOrders",
      },
    ],
  },

  {
    to: "/admin/payments",
    label: "Payments",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "payments",
    // subNav: [
    //   {
    //     to: "/admin/payments/advance-requested",
    //     label: "Advance Requested",
    //     iconName: ledgerActive,
    //     inactiveIcon: ledgerIA,
    //     privilegesName: "advanceRequested",
    //   },
    //   {
    //     to: "/admin/payments/paid",
    //     label: "Paid",
    //     iconName: ledgerActive,
    //     inactiveIcon: ledgerIA,
    //     privilegesName: "paid",
    //   },
    //   {
    //     to: "/admin/payments/outstanding",
    //     label: "Outstanding",
    //     iconName: ledgerActive,
    //     inactiveIcon: ledgerIA,
    //     privilegesName: "outstanding",
    //   },
    // ],
  },
  {
    to: "/admin/download-ledger",
    label: "Download Ledger",
    iconName: ledgerActive,
    inactiveIcon: ledgerIA,
    privilegesName: "downloadLedger",
  },
];

export const navLinkAgent = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/commodity-deposits",
    label: "Commodity Deposits",
    iconName: ledgerActive,
    inactiveIcon: ledgerIA,
    privilegesName: "commodityDeposits",
  },
  {
    to: "",
    label: "Assigned Quantity",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "purchaseorders",
    subNav: [
      {
        to: "/admin/purchaseorders/completed",
        label: "Completed",
        iconName: agreementActive,
        inactiveIcon: agreementIA,
        privilegesName: "completed",
      },
      {
        to: "/admin/purchaseorders/ongoing",
        label: "Ongoing",
        iconName: purchaseActive,
        inactiveIcon: purchaseIA,
        privilegesName: "ongoing",
      },
    ],
  },
];

export const navLinkSupplier = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Bid/Quotation Requests",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "bidQuotationRequests",
    subNav: [
      {
        to: "/admin/bidQuotation/submittedBids",
        label: "Submitted Bids",
        iconName: agreementActive,
        inactiveIcon: agreementIA,
        privilegesName: "submittedBids",
      },
      {
        to: "/admin/bidQuotation/ongoingBids",
        label: "Ongoing Bids",
        iconName: purchaseActive,
        inactiveIcon: purchaseIA,
        privilegesName: "ongoingBids",
      },
    ],
  },
  {
    to: "",
    label: "Purchase Orders",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "purchaseorders",
    subNav: [
      {
        to: "/admin/purchaseorders/completed",
        label: "Completed",
        iconName: agreementActive,
        inactiveIcon: agreementIA,
        privilegesName: "completed",
      },
      {
        to: "/admin/purchaseorders/ongoing",
        label: "Ongoing",
        iconName: purchaseActive,
        inactiveIcon: purchaseIA,
        privilegesName: "ongoing",
      },
    ],
  },
  {
    to: "",
    label: "Payments",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "payments",
    subNav: [
      {
        to: "/admin/payments/total-bill-raised",
        label: "Total bill raised",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "totalbillraised",
      },
      {
        to: "/admin/payments/quality-quantity-discount",
        label: "Quality & Quantity discount",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "qualityandquantitydiscount",
      },
      {
        to: "/admin/payments/outstanding",
        label: "Outstanding",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "outstanding",
      },
    ],
  },
  {
    to: "/admin/download-ledger",
    label: "Download Ledger",
    iconName: ledgerActive,
    inactiveIcon: ledgerIA,
    privilegesName: "downloadLedger",
  },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
  // {
  //   to: "/admin/commodity-deposits",
  //   label: "Commodity Deposits",
  //   iconName: ledgerActive,
  //   inactiveIcon: ledgerIA,
  //   privilegesName: "commodityDeposits",
  // },
];

export const navLinkbusinessDev = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/onBoardings/customer",
    label: "Customer",
    iconName: ledgerActive,
    inactiveIcon: ledgerIA,
    privilegesName: "customer",
  },
  // {
  //   to: "/admin/submit-request",
  //   label: "Submit Request",
  //   iconName: dashActive,
  //   inactiveIcon: dashIA,
  //   privilegesName: "submitRequest",
  // },
  {
    to: "/admin/purchase-orders",
    label: "Purchase Orders",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "purchaseOrders",
  },
  {
    to: "/admin/release-order",
    label: "Release orders",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "releaseOrders",
  },
  // {
  //   to: "",
  //   label: "OnBoardings",
  //   iconName: locationIA,
  //   inactiveIcon: locationIA,
  //   privilegesName: "onBoardings",
  //   subNav: [
  //     {
  //       to: "/admin/onBoardings/customer",
  //       label: "Customer",
  //       iconName: ledgerActive,
  //       inactiveIcon: ledgerIA,
  //       privilegesName: "customer",
  //     },
  //   ],
  // },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkCog = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Value Chain Management",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "valueChainManage",
    subNav: [
      {
        to: "/admin/value-chain-manage/approvals",
        label: "Requests Submitted",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "cogApprovals",
      },
      {
        to: "/admin/value-chain-manage/purchase-request",
        label: "Purchase Request",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "purchaseRequest",
      },
      // {
      //   to: "/admin/value-chain-manage/requests-submitted",
      //   label: "Requests Submitted",
      //   iconName: ledgerActive,
      //   inactiveIcon: ledgerIA,
      //   privilegesName: "requestsSubmitted",
      // },
      {
        to: "/admin/value-chain-manage/addendum",
        label: "Addendum",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "addendum",
      },

      {
        to: "/admin/value-chain-manage/supplier-bids",
        label: "Supplier Bids",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "supplierBids",
      },

      {
        to: "/admin/value-chain-manage/deposit-updates",
        label: "Deposit Updates",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "depositUpdate",
      },
      {
        to: "/admin/value-chain-manage/alltransactionsdetails",
        label: "All Transactions",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "allTransactions",
      },
    ],
  },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkAreaManager = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/approvals",
    label: "Approvals",
    iconName: approvalsIcon,
    inactiveIcon: approvalsIA,
    privilegesName: "approvals",
  },
  {
    to: "",
    label: "Onboardings",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "onBoardings",
    subNav: [
      {
        to: "/admin/onboardings/grain-manager",
        label: "Grain Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "grainManager",
      },

      {
        to: "/admin/onboardings/customer",
        label: "Customer",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "customer",
      },
      {
        to: "/admin/onboardings/cluster-manager",
        label: "Cluster Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "clusterManager",
      },
      {
        to: "/admin/onboardings/business-devolpment-exective",
        label: "BDE",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "bde",
      },
      {
        to: "/admin/onboardings/locations",
        label: "Locations",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "locations",
      },

      {
        to: "/admin/onboardings/commodities",
        label: "Commodities",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "commodities",
      },
    ],
  },
  {
    to: "/admin/proposal-submission",
    label: "Proposal from VCM",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "proposalSubmission",
  },

  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkGrainManager = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/bookings",
    label: "Bookings",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "bookings",
  },
  {
    to: "/admin/maintenance",
    label: "Maintenance",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "maintenance",
  },
  {
    to: "/admin/fumigation-and-spraying",
    label: "Fumigation & Spraying",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "fumigationAndSpraying",
  },
  {
    to: "/admin/commodity-deposits",
    label: "Commodity Deposits",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "commodityDeposits",
  },
  {
    to: "/admin/commodity-health",
    label: "Commodity Health",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "commodityHealth",
  },
  {
    to: "/admin/commodity-release",
    label: "Commodity Release",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "commodityRelease",
  },

  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkQualityManager = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/pending-tasks",
    label: "Pending Tasks",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "pendingTasks",
  },
];

export const navLinkSuperAdmin = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/team-members",
    label: "Team Members",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "teamMembers",
  },
  {
    to: "/admin/agreements",
    label: "Agreements",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "agreements",
  },
  {
    to: "/admin/pending-approval",
    label: "Pending Approval",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "pendingApproval",
  },
  {
    to: "/admin/onboards",
    label: "Onboards",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "onboards",
  },
  {
    to: "/admin/deposited-commodities",
    label: "Deposited Commodities",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "depositedCommodities",
  },
  {
    to: "/admin/value-chain-management",
    label: "VCM",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "valueChainManagement",
  },
  {
    to: "/admin/ticket",
    label: "Ticket",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "ticket",
  },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkClusterManager = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Onboardings",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "onBoardings",
    subNav: [
      {
        to: "/admin/onboardings/business-devolpment-exective",
        label: "BDE",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "bde",
      },

      {
        to: "/admin/onboardings/supplier",
        label: "Supplier",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "supplier",
      },
      {
        to: "/admin/onboardings/customer",
        label: "Customer",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "customer",
      },
      {
        to: "/admin/onboardings/location",
        label: "Location",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "location",
      },

      {
        to: "/admin/onboardings/commodities",
        label: "Commodities",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "commodities",
      },
    ],
  },
  {
    to: "/admin/ticket",
    label: "Ticket",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "tickets",
  },

  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkZonalManager = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Onboardings",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "onBoardings",
    subNav: [
      {
        to: "/admin/onboardings/cluster-manager",
        label: "Cluster Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "clusterManager",
      },
      {
        to: "/admin/onboardings/business-devolpment-exective",
        label: "BDE",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "bde",
      },
      {
        to: "/admin/onboardings/area-manager",
        label: "Area Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "areaManager",
      },

      {
        to: "/admin/onboardings/supplier",
        label: "Supplier",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "supplier",
      },
      {
        to: "/admin/onboardings/customer",
        label: "Customer",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "customer",
      },
      {
        to: "/admin/onboardings/location",
        label: "Location",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "location",
      },
      {
        to: "/admin/onboardings/commodities",
        label: "Commodities",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "commodities",
      },
    ],
  },
  {
    to: "/admin/ticket",
    label: "Ticket",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "tickets",
  },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkBusinessHead = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Onboardings",
    iconName: locationIA,
    inactiveIcon: locationIA,
    privilegesName: "onBoardings",
    subNav: [
      {
        to: "/admin/onboardings/cluster-manager",
        label: "Cluster Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "clusterManager",
      },
      {
        to: "/admin/onboardings/business-devolpment-exective",
        label: "BDE",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "clusterManager",
      },
      {
        to: "/admin/onboardings/area-manager",
        label: "Area Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "areaManager",
      },
      {
        to: "/admin/onboardings/supplier",
        label: "Supplier",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "supplier",
      },
      {
        to: "/admin/onboardings/customer",
        label: "Customer",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "customer",
      },
      {
        to: "/admin/onboardings/zonal-manager",
        label: "Zonal Manager",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "zonalManager",
      },

      {
        to: "/admin/onboardings/location",
        label: "Location",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "location",
      },
      {
        to: "/admin/onboardings/commodities",
        label: "Commodities",
        iconName: ledgerActive,
        inactiveIcon: ledgerIA,
        privilegesName: "commodities",
      },
      // {
      //   to: "/admin/onboardings/grain-manager",
      //   label: "Grain Manager",
      //   iconName: ledgerActive,
      //   inactiveIcon: ledgerIA,
      //   privilegesName: "grainManager",
      // },
    ],
  },
  {
    to: "/admin/ticket",
    label: "Ticket",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "tickets",
  },
  {
    to: "/admin/deposited-commodities",
    label: "DepositedCommodities",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "depositedCommodities",
  },
  // {
  //   to: "/admin/setting",
  //   label: "Settings",
  //   iconName: settingActive,
  //   inactiveIcon: settingIA,
  //   privilegesName: "setting",
  // },
];

export const navLinkGrainDepositor = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashboardActive,
    inactiveIcon: dashboardIA,
    privilegesName: "dashboard",
    subNav: [
      {
        to: "/admin/dashboard/reservation-history",
        label: "Reservation History",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "reservationHistory",
      },
      {
        to: "/admin/dashboard/agreement-execute",
        label: "Agreement Executed",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "agreementExecute",
      },
      {
        to: "/admin/dashboard/stock-report",
        label: "Stock Report",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "stockReport",
      },
      {
        to: "/admin/dashboard/warehouse-receipt-request",
        label: "Warehouse Receipt & Request",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "warhouseReceiptRequest",
      },
      {
        to: "/admin/dashboard/outstanding-invoice",
        label: "Outstanding Invoice",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "outstandingInvoice",
      },
      {
        to: "/admin/dashboard/overall-ledger",
        label: "Overall Ledger",
        iconName: homeActive,
        inactiveIcon: homeIA,
        privilegesName: "overAllLedger",
      },
    ],
  },
  {
    to: "/admin/banking",
    label: "Banking",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "banking",
  },
  {
    to: "/admin/myagents",
    label: "My Agents",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "myagents",
  },
  {
    to: "/admin/payment",
    label: "Payment",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "payments",
  },
  {
    to: "/admin/warehouse",
    label: "Warehouse",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "warehouse",
  },
  {
    to: "/admin/quotation",
    label: "Quotation",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "quotation",
  },
  {
    to: "/admin/certificates",
    label: "Certificates",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "certificates",
  },
  {
    to: "/admin/customer-care",
    label: "Customer Care",
    iconName: settingActive,
    inactiveIcon: settingIA,
    privilegesName: "customerCare",
  },
  {
    to: "/admin/tickets",
    label: "Tickets",
    iconName: ticketsActive,
    inactiveIcon: ticketsIA,
    privilegesName: "tickets",
  },
];

export const navLinkCogOnboarding = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "/admin/customer",
    label: "Customers",
    iconName: groupPeopleActive,
    inactiveIcon: groupPeopleIA,
    privilegesName: "customers",
  },
  {
    to: "/admin/warehouses",
    label: "Warehouses",
    iconName: homeActive,
    inactiveIcon: homeIA,
    privilegesName: "warehouses",
  },
  {
    to: "/admin/vendor",
    label: "Vendor",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "vendor",
  },

  {
    to: "/admin/location",
    label: "Location",
    iconName: locationActive,
    inactiveIcon: locationIA,
    privilegesName: "location",
  },
  {
    to: "/admin/manpower",
    label: "Manpower",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "manpower",
  },
  {
    to: "/admin/insurance-policy",
    label: "Insurance Policy",
    iconName: homeActive,
    inactiveIcon: homeIA,
    privilegesName: "insurancePolicy",
  },
  {
    to: "/admin/commodity-list",
    label: "Commodity List",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "commodityList",
  },
];

export const navLinkFinanceTeamMember = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    iconName: dashActive,
    inactiveIcon: dashIA,
    privilegesName: "dashboard",
  },
  {
    to: "",
    label: "Value Chain Management",
    iconName: homeActive,
    inactiveIcon: homeIA,
    privilegesName: "valueChainManage",
    subNav: [
      {
        to: "/admin/value-chain-manage/all-transactions",
        label: "All Transactions",
        iconName: bankActive,
        inactiveIcon: bankIA,
        privilegesName: "allTransaction",
      },
      {
        to: "/admin/value-chain-manage/deposits",
        label: "Deposits",
        iconName: bankActive,
        inactiveIcon: bankIA,
        privilegesName: "deposits",
      },
      {
        to: "/admin/value-chain-manage/release-rate",
        label: "Release Rate",
        iconName: bankActive,
        inactiveIcon: bankIA,
        privilegesName: "releaseRate",
      },
      {
        to: "/admin/value-chain-manage/invoice",
        label: "Invoice / E-way Bill Upload",
        iconName: bankActive,
        inactiveIcon: bankIA,
        privilegesName: "invoice",
      },
    ],
  },
];
